import { Route, Routes } from "react-router-dom";
import CompanyTreeRouter from "./CompanyTree";

export default function EmployeeManagementRouter() {
  return (
    <Routes>
      <Route path="/tree/*" element={<CompanyTreeRouter />} />
    </Routes>
  );
}
